<template>
  <div class="page-wrapper">

    <!-- HEADER -->
    <div class="fixed-top" id="header-fixed-lite">
      <router-link to="/" class="header-link">
        <table class="header-table">
          <tbody>
            <tr>
              <td rowspan="3">
                <img src="@/assets/apdcl_logo.png" alt="APDCL Logo" class="logo" />
              </td>
            </tr>
            <tr>
              <td class="title-a text-blue">
                অসম শক্তি বিতৰণ কোম্পানী লিমিটেড
              </td>
            </tr>
            <tr>
              <td class="title-e text-blue">
                ASSAM POWER DISTRIBUTION COMPANY LIMITED
              </td>
            </tr>
          </tbody>
        </table>
      </router-link>
    </div>

    <!-- CONTENT -->
    <b-container fluid class="content-wrapper">

      <!-- BREADCRUMB -->
      <b-row>
        <b-col cols="12">
          <b-breadcrumb class="breadcrumb-bg">
            <b-breadcrumb-item to="/career">
              <b-icon icon="house-door-fill"></b-icon> Career
            </b-breadcrumb-item>
            <b-breadcrumb-item active>Download Appointment Letter</b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>

        <b-col cols="12">
          <h3 class="text-center mb-4">SAHAYAK APPOINTMENT LETTER DOWNLOAD</h3>
        </b-col>
      </b-row>


      <b-row align-h="center" class="mt-4">
        <b-col cols="12" sm="10" md="6" lg="4">
          <b-card class="login-card shadow-sm">

            <b-form-group class="form-group-custom">
              <label class="form-label">
                <b-icon icon="person" class="label-icon"></b-icon>
                Roll Number
              </label>
              <b-form-input v-model="rollNo" type="text" inputmode="numeric" maxlength="8"
                oninput="this.value = this.value.replace(/\D/g,'')" placeholder="Enter Roll Number"
                class="form-input" />
            </b-form-group>

            <b-form-group class="form-group-custom">
              <label class="form-label">
                <b-icon icon="calendar-date" class="label-icon"></b-icon>
                Date of Birth
              </label>
              <b-form-input v-model="dob" type="date" class="form-input" />
            </b-form-group>

            <b-button block variant="primary" :disabled="loading" @click="login">
              <b-icon icon="download" class="mr-2"></b-icon>
              {{ loading ? 'Checking...' : 'DOWNLOAD' }}
            </b-button>

          </b-card>

       
          <b-modal id="download-modal" :title="modalTitle" hide-footer centered size="md">

            <!-- QUALIFIED -->
            
<div v-if="modalStatus === 'success'" class="success-card">

  <div class="text-center mb-3">
    <h4 class="text-success font-weight-bold">Congratulations!</h4>
    <p class="text-muted mb-1">Welcome to</p>
    <h6 class="font-weight-bold text-uppercase">
      Assam Power Distribution Company Limited
    </h6>
  </div>

  <hr />

  <div class="details">
    <div class="row mb-2">
      <div class="col-5 label">Candidate Name</div>
      <div class="col-7 value">{{ candidate_name }}</div>
    </div>

    <div class="row mb-2">
      <div class="col-5 label">Roll Number</div>
      <div class="col-7 value">{{ rollNo}}</div>
    </div>

    <div class="row mb-2">
      <div class="col-5 label">Department</div>
      <div class="col-7 value">APDCL</div>
    </div>

    <div class="row mb-2">
      <div class="col-5 label">Designation</div>
      <div class="col-7 value">Sahayak</div>
    </div>

    <div class="row mb-3">
      <div class="col-5 label">Grade</div>
      <div class="col-7 value">Grade-IV</div>
    </div>
  </div>

  <b-button
    block
    variant="success"
    size="lg"
    :disabled="!appointmentPdf"
    @click="downloadAppointment"
  >
    <b-icon icon="download" class="mr-2"></b-icon>
    Download Appointment Letter (PDF)
  </b-button>

</div>


            <!-- NOT QUALIFIED -->
            <div v-else class="text-center py-4">
              <b-icon icon="x-circle-fill" variant="danger" font-scale="3" class="mb-3"></b-icon>

              <h5 class="text-danger mb-2">
                No Data Found
              </h5>

              <p class="text-muted mb-0">
                Please check your <strong>Roll Number</strong> and <strong>Date of Birth</strong>
              </p>
            </div>

          </b-modal>

        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "LoginPage",
  data() {
    return {
      candidate_name: "",
      rollNo: "",
      dob: "",
      loading: false,
      modalTitle: '',
      modalStatus: "", // 'success' | 'failed'
      appointmentPdf: "",
     
    };
  },
  methods: {
    async login() {
      if (!this.rollNo) {
        this.$bvToast.toast(
          "Please enter Roll Number",
          {
            title: "Alert",
            variant: "danger",
            solid: true
          }
        );
        return;
      }

      if (!this.dob) {
        this.$bvToast.toast(
          "Please enter Date of Birth",
          {
            title: "Alert",
            variant: "danger",
            solid: true
          }
        );
        return;
      }


      try {
        this.loading = true;

        const url = this.$parent.$urlCommon + "/api/web/career/sahayak/getAppointmentLetter" + "?rollNo=" + this.rollNo + "&dob=" + this.dob;

        const response = await axios.get(url);



        console.log("response data", JSON.stringify(response.data));


        if (response.data.status === "success") {
          this.modalStatus = "success";
          this.candidate_name=response.data.name;
          this.rollNo=response.data.roll_no;
          this.appointmentPdf = response.data.link_english || "";
          //this.assamesePdf = response.data.link_assamese || "";

        }
        else {
          this.modalStatus = "failed";
        }

        this.$bvModal.show("download-modal");

      } catch (error) {
        console.error(error);
        this.modalStatus = "failed";
        this.$bvModal.show("download-modal");

        /*this.$bvToast.toast(
          "Unable to verify details. Please try again later.",
          {
            title: "Error",
            variant: "danger",
            solid: true
          }
        );*/
      } finally {
        this.loading = false;
      }
    },
   
    downloadAppointment() {
      if (this.appointmentPdf) {
        window.open(this.appointmentPdf, "_blank");
      }
    },

   /* downloadAssamese() {
      if (this.assamesePdf) {
        window.open(this.assamesePdf, "_blank");
      }
    }*/
  }
};
</script>


<style scoped>
.page-wrapper {
  min-height: 100vh;
  background: #f5f7fa;
}


#header-fixed-lite {
  background-color: #ffffff;
  box-shadow: 0 4px 7px 1px #e0e0e0;
  padding: 10px 20px;
  z-index: 1000;
}

.header-link {
  text-decoration: none;
}


.header-table {
  border-collapse: collapse;
}

.header-table td {
  vertical-align: middle;
  text-align: left;
}


.logo {
  height: 75px;
  width: 75px;
  margin-right: 15px;
}


.title-a {
  font-family: Assamese_Font, Arial, sans-serif;
  font-size: 1.3rem;
  font-weight: 900;
  letter-spacing: 0.5px;
}

.title-e {
  font-size: 1.3rem;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.text-blue {
  color: #01579b;
}


.content-wrapper {
  padding-top: 100px;
  /* space for fixed header */
  padding-bottom: 40px;
}


.breadcrumb-bg {
  background-color: #e9ecef78;
  border-radius: 4px;
}


.login-card {
  border-radius: 10px;
  padding: 20px;
}



.form-group-custom {
  margin-bottom: 1.6rem;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  color: #01579b;
  margin-bottom: 6px;
  letter-spacing: 0.3px;
}

.label-icon {
  color: #0288d1;
  font-size: 1.05rem;
}

.form-input {
  border-radius: 8px;
  padding: 10px 12px;
  border: 1px solid #cfd8dc;
  transition: all 0.2s ease-in-out;
}


.form-input:focus {
  border-color: #0288d1;
  box-shadow: 0 0 0 2px rgba(2, 136, 209, 0.15);
}


.form-input::placeholder {
  color: #9e9e9e;
  font-size: 0.85rem;
}

@font-face {
  font-family: Assamese_Font;
  src: url("../assets/Assamese_font/KirtanUni.ttf");
}

div {
  font-family: arial, Assamese_Font;
}

/* ---------------- MOBILE ---------------- */
@media (max-width: 576px) {
  .logo {
    height: 55px;
    width: 55px;
  }

  .title-a {
    font-size: 1.05rem;
  }

  .title-e {
    font-size: 0.95rem;
  }

  .content-wrapper {
    padding-top: 120px;
  }
}
</style>